import { Button, Group, Modal, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface ConfirmDialogProps {
  opened: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  opened,
  title,
  message,
  confirmLabel,
  cancelLabel,
  danger = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { t } = useTranslation('common');
  return (
    <Modal opened={opened} onClose={onCancel} title={title ?? t('confirm.title')} centered>
      <Stack>
        <Text>{message ?? t('confirm.message')}</Text>
        <Group justify="flex-end">
          <Button variant="default" onClick={onCancel}>
            {cancelLabel ?? t('actions.cancel')}
          </Button>
          <Button color={danger ? 'red' : 'blue'} onClick={onConfirm}>
            {confirmLabel ?? t('actions.confirm')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
